import { render } from "./PlayerDisabled.vue?vue&type=template&id=16cdc356&scoped=true"
const script = {}

import "./PlayerDisabled.vue?vue&type=style&index=0&id=16cdc356&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16cdc356"]])

export default __exports__